
  <section class="page-banner-sec" [style.background-image]="'url(' + (pageData?.image ? pageData?.image  :'assets/img/about-page-banner.png') + ')'" >
    <div class="container">
        <h1 class="page-banner-title">{{pageData?.title}}</h1>
    </div>
  </section>

  <section class="pt-5">
      <div class="container text-76" [innerText]="pageData?.description">
         
      </div>
  </section>

  <section class="">
      <div class="container">
          <div class="row two-part-img-text my-5">
              <div class="col-lg-6">
                  <div class="part-img">
                    <img class="img-responsive" [src]="pageData?.jsonKey[0]?.content[0]?.image? pageData?.jsonKey[0]?.content[0]?.image:'assets/img/about-ride.png'">
                  </div>
              </div>
              <div class="col-lg-6">
                <div class="part-text">
                  <h2 class="text-76" class="font-weight-bold">{{pageData?.jsonKey[0]?.content[0]?.title}}</h2>
                <p [innerText]="pageData?.jsonKey[0]?.content[0]?.description">

                </p>
                </div>
            </div>
          </div>
            <div class="row two-part-img-text my-5 flex-lg-row-reverse">
                <div class="col-lg-6">
                    <div class="part-img">
                        <img class="img-responsive" [src]="pageData?.jsonKey[0]?.content[1]?.image? pageData?.jsonKey[0]?.content[1]?.image:'assets/img/about-safty.png'">
                    </div>
                </div>
                <div class="col-lg-6">
                  <div class="part-text">
                      <h2 class="font-weight-bold">{{pageData?.jsonKey[0]?.content[1]?.title}}</h2>
                      <p [innerText]="pageData?.jsonKey[0]?.content[1]?.description"></p>

                     </div>
              </div>
          </div>
      </div>
  </section>
  <section class="about-company-info-sec">
    <div class="container">
        <div class="row">
            <div class="col-xl-6">
                <div class="aci-img">
                    <img [src]="pageData?.jsonKey[0]?.companyInfo?.image? pageData?.jsonKey[0]?.companyInfo?.image:'assets/img/aci-img.jpg'">
                </div>
            </div>
            <div class="col-xl-6">
                <div class="aci-text">
                    <h2 class="font-weight-bold">{{pageData?.jsonKey[0]?.companyInfo?.title}}</h2>
                    <p [innerText]="pageData?.jsonKey[0]?.companyInfo?.description"></p>
                    <div class="row mt-4">
                        <div class="col-sm-6 border-right">
                            <div class="aci-text-sub">
                                <h3>{{pageData?.jsonKey[0]?.companyInfo?.content[0].title}}</h3>
                              <p [innerText]="pageData?.jsonKey[0]?.companyInfo?.content[0].description"></p>
                              </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="aci-text-sub pl-sm-1">
                                <h3>{{pageData?.jsonKey[0]?.companyInfo?.content[1].title}}</h3>
                              <p [innerText]="pageData?.jsonKey[0]?.companyInfo?.content[1].description"></p>
                              </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>

